import React from 'react';
import { BarChart3 } from 'lucide-react';

const AgentAdoptionChart = ({ stats }) => {
  const agentNames = {
    'marketing-ops': 'Marketing Operations',
    'personal-productivity': 'Personal Productivity',
    'feedback-analytics': 'Feedback & Analytics',
    'onboarding': 'Onboarding Agent'
  };

  const agentColors = {
    'marketing-ops': { bg: 'bg-blue-500', light: 'bg-blue-100' },
    'personal-productivity': { bg: 'bg-emerald-500', light: 'bg-emerald-100' },
    'feedback-analytics': { bg: 'bg-orange-500', light: 'bg-orange-100' },
    'onboarding': { bg: 'bg-rose-500', light: 'bg-rose-100' }
  };

  if (!stats?.byAgent || Object.keys(stats?.byAgent)?.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
          <BarChart3 className="w-5 h-5 text-gray-400" />
          Agent Adoption by Team
        </h3>
        <div className="text-center py-8">
          <BarChart3 className="w-12 h-12 text-gray-400 mx-auto mb-3" />
          <p className="text-gray-600">No agent usage data yet</p>
        </div>
      </div>
    );
  }

  // Calculate total for percentages
  const totalInteractions = Object.values(stats?.byAgent)?.reduce(
    (sum, agent) => sum + (agent?.interactions || 0),
    0
  );

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
        <BarChart3 className="w-5 h-5 text-gray-400" />
        Agent Adoption by Team
      </h3>
      <div className="space-y-4">
        {Object.entries(stats?.byAgent)?.map(([agentId, agentStats]) => {
          const percentage = totalInteractions > 0 
            ? ((agentStats?.interactions || 0) / totalInteractions) * 100 
            : 0;
          const colors = agentColors?.[agentId] || { bg: 'bg-gray-500', light: 'bg-gray-100' };

          return (
            <div key={agentId} className="space-y-2">
              <div className="flex items-center justify-between">
                <span className="text-sm font-medium text-gray-700">
                  {agentNames?.[agentId] || agentId}
                </span>
                <div className="flex items-center gap-4 text-sm text-gray-600">
                  <span>{agentStats?.interactions || 0} interactions</span>
                  <span className="font-medium">{percentage?.toFixed(1)}%</span>
                </div>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
                <div
                  className={`h-full ${colors?.bg} transition-all duration-300`}
                  style={{ width: `${percentage}%` }}
                />
              </div>
              <div className="flex items-center gap-4 text-xs text-gray-500">
                <span>{agentStats?.tasks || 0} tasks</span>
                <span>•</span>
                <span>{agentStats?.content || 0} content items</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AgentAdoptionChart;